module.exports = __webpack_public_path__ + "static/media/to_right.2344900d.svg";